module.exports = __webpack_public_path__ + "static/media/search.4007f49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/search.png
// module id = 977
// module chunks = 0